import { render, staticRenderFns } from "./SearchTableFooter.vue?vue&type=template&id=04dccf89"
import script from "./SearchTableFooter.vue?vue&type=script&lang=js"
export * from "./SearchTableFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports